<template>
  <nav class="ui-tabs">
    <button
      v-for="item in items"
      :key="item"
      class="ui-tabs__item"
      :class="{ active: item === value }"
      @click="$emit('input', item)"
    >
      {{ item }}
    </button>
  </nav>
</template>

<script>
export default {
  name: 'ui-tabs',
  props: {
    items: Array,
    value: String
  }
}
</script>

<style lang="scss">
.ui-tabs {
  display: flex;
  margin-bottom: 2rem;
  &__item {
    margin-right: 2rem;
    font-weight: 600;
    font-size: 18px;
    border: 0;
    padding: 0;
    background-color: transparent;
    color: $gray-600;
    border-bottom: 2px solid transparent;
    transition: .2s;
    &:hover {
      color: $gray-700;
    }
    &.active {
      color: $primary;
      border-bottom-color: currentColor;
    }

  }
}
// .ui-tabs {
//   display: flex;
//   border-bottom: 1px solid $gray-400;
//   &__item {
//     margin-bottom: -1px;
//     padding: 0.5rem 1rem;
//     color: $gray-600;
//     font-size: 14px;
//     text-transform: uppercase;
//     background-color: transparent;
//     border: 0;
//     border: 1px solid transparent;
//     border-bottom: 1px solid $gray-400;
//     border-radius: 4px 4px 0 0;
//     outline: none;
//     transition: 0.2s;
//     &:hover {
//       color: $gray-800;
//     }
//     &.active {
//       color: $black;
//       background-color: $white;
//       border-color: $gray-400;
//       border-bottom-color: $white;
//     }
//   }
// }
</style>
